import {
  GET_ENCAISSEMENT_LINES,
  ADD_ENCAISSEMENT_LINE,
  DELETE_ENCAISSEMENT_LINE,
  CLEAR_ENCAISSEMENT_LINES
} from '../types';
import { IAction, IEncaissementLine } from '../../types/interfaces';

const initialState = {
  encaissementlines: []
};

interface IState {
  encaissementlines: IEncaissementLine[];
}

export default function(state: IState = initialState, action: IAction) {
  switch (action.type) {
    case GET_ENCAISSEMENT_LINES:
      return {
        ...state,
        encaissementlines: action.payload
      };
    case DELETE_ENCAISSEMENT_LINE:
      return {
        ...state,
        encaissementlines: state.encaissementlines.filter(encaissementline => encaissementline.lineIndex !== action.payload)
      };
    case CLEAR_ENCAISSEMENT_LINES:
      state.encaissementlines.forEach(e => {
        if(e.recto && e.recto["preview"])
          URL.revokeObjectURL(e.recto["preview"])
        if(e.verso && e.verso["preview"])
          URL.revokeObjectURL(e.verso["preview"])


        if(e.recto && e.recto["preview"])
          console.log("cleared recto?")
      })
      return {
        ...state,
        encaissementlines: []
      };
    case ADD_ENCAISSEMENT_LINE:
      return {
        ...state,
        encaissementlines: [...state.encaissementlines, action.payload]
      };
    default:
      return state;
  }
}
